/**
 * The assistant is composing.
 *
 * Shown only between sending and the first token — once text is arriving, the
 * text itself is the indicator. Three dots, staggered, `--text-quiet`; the
 * keyframes are in styles.css and stop under `prefers-reduced-motion`.
 */

import { EASE } from '../../theme';

export function TypingDots() {
  return (
    <span
      role="status"
      aria-label="Writing"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 0' }}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            width: 5,
            height: 5,
            borderRadius: '50%',
            background: 'var(--text-quiet)',
            animation: `mvDot 1.2s ${EASE} ${i * 0.16}s infinite`
          }}
        />
      ))}
    </span>
  );
}
